<!-- <template>
  <div>
    <div class="mb-3 border-bottom mt-5">

      <div v-if="pf == 1" class="company-form-box-title">Board of Trustees Management for Provident Fund</div>
      <div v-else class="company-form-box-title">Board of Trustees Management for Gratuity Fund</div>
    </div>

    <div class="d-flex">
      <div class="d-flex">
        <button class="btn tab-btn" :class="{ active: activeTab == 'current' }" @click="switchTab('current')">Current Members</button>
        <button class="btn tab-btn" :class="{ active: activeTab == 'former' }" @click="switchTab('former')">Former Members</button>
        <button class="btn tab-btn" :class="{ active: activeTab == 'settings' }" @click="switchTab('settings')">Settings</button>
      </div>
    </div>

    <div class="mt-3">
      <div v-if="activeTab === 'current'">
        <members :key="componentKey" :pf="pf" :status="1"></members>
      </div>
      <div v-else-if="activeTab === 'former'">
        <members :key="componentKey" :pf="pf" :status="0"></members>
      </div>
      <div v-else-if="activeTab === 'settings'">
        <b-tabs :key="componentKey" content-class="mt-3">
          <b-tab lazy title="Roles"><bot-roles></bot-roles></b-tab>
          <b-tab lazy title="Representative"><bot-representatives></bot-representatives></b-tab>
        </b-tabs>
      </div>
    </div>
  </div>
</template> -->
<template>
  <div>
    <div class="row no-gutters mb-3 mt-3">
      <div class="col-md-12 col-sm-12" v-if="pf == 1">
        <h4 class="atlhr-dashboard-title mt-10">
            Board of Trustee Management for Provident Fund <span class="black-title"></span>
            <span>
                <a v-bind:href="$api_url+'/'">Dashboard</a>
                / PF Board of Trustee Members
            </span>
        </h4>
      </div> 
      <div class="col-md-12 col-sm-12" v-else-if="pf == 2">
        <h4 class="atlhr-dashboard-title mt-10">
            Board of Trustee Management for Welfare Fund <span class="black-title"></span>
            <span>
                <a v-bind:href="$api_url+'/'">Dashboard</a>
                / WF Board of Trustee Members
            </span>
        </h4>
      </div>
      <div class="col-md-12 col-sm-12" v-else>
        <h4 class="atlhr-dashboard-title mt-10">
            Board of Trustee Management for Gratuity Fund <span class="black-title"></span>
            <span>
                <a v-bind:href="$api_url+'/'">Dashboard</a>
                / GF Board of Trustee Members
            </span>
        </h4>
      </div>
    </div>

    <div class="mt-4 employee-tab leave-attendance-dashboard">
      <b-tabs pills content-class="" nav-class="pr-2 m-2 leave-attendance-dashboard-tab" nav-wrapper-class="col-md-12 custom-tab-nav custom-margin ml-auto pl-0 bg-white">
        <b-tab lazy class="ibox">
          <template v-slot:title>Current Members</template>
          <div class="tab-item-wrapper pt-0">
            <members :key="componentKey" :pf="pf" :status="1" />
          </div>
        </b-tab>

        <b-tab lazy class="ibox">
          <template v-slot:title>Former Members</template>
          <div class="tab-item-wrapper pt-0">
            <members :key="componentKey" :pf="pf" :status="0" />
          </div>
        </b-tab>

        <b-tab lazy class="ibox" v-if="$acl['bot/'+types[pf]] == 2">
          <template v-slot:title>Settings</template>
          <div class="mt-2 employee-tab leave-attendance-dashboard investment-inner">

            <b-form-group  class="investment_radio_input_group" v-slot="{ ariaDescribedby }">
              <b-form-radio-group id="radio-slots" v-model="selected" :aria-describedby="ariaDescribedby" name="radio-options-slots">

                <b-form-radio  value="roles">Roles</b-form-radio>
                <b-form-radio  value="representative">Representative</b-form-radio>
                                   
              </b-form-radio-group>
            </b-form-group>

            <b-tabs pills content-class="" nav-class=" pr-2 m-2 leave-attendance-dashboard-tab fundinvestment_processing_tab" nav-wrapper-class="col-md-12 custom-tab-nav custom-margin ml-auto pl-0 bg-white">

              <template >

                <b-tab lazy :active="selected == 'roles'">

                  <div class="tab-item-wrapper">
                    <bot-roles :pf="pf"></bot-roles>
                  </div>

                </b-tab>
                <b-tab lazy :active="selected == 'representative'">

                  <div class="tab-item-wrapper">
                    <bot-representatives :pf="pf"></bot-representatives>
                  </div>

                </b-tab>
              </template>
            </b-tabs>

            <!-- <b-tabs content-class="mt-3">
              <b-tab lazy title="Roles">
                <bot-roles></bot-roles>
              </b-tab>
              <b-tab lazy title="Representative">
                <bot-representatives></bot-representatives>
              </b-tab>
            </b-tabs> -->

          </div>
        </b-tab>
      </b-tabs>
    </div>
  </div>
</template>


<script>
import BotRepresentatives from "./BotRepresentatives.vue";
import BotRoles from "./BotRoles.vue";
import Members from "./Members.vue";

export default {
  name: "trustee-fund-types",
  props: ["pf"],
  components: { BotRepresentatives, BotRoles, Members },
  data() {
    return {
      types:{0:'gf' , 1:'pf', 2:'wf'},
      componentKey: 0,
      activeTab: "current",

      selected:'roles',
    };
  },
  methods: {

  },
};
</script>
